module.exports = __webpack_public_path__ + "opticutIco.webp?f3e32a4223ce0d92d8a6c628b47f80d4";